import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { 
  GET_REVIEWS, 
  // GET_ADMIN_PROFILE,
  ADD_NEW_REVIEW,
  UPDATE_REVIEW,
  DELETE_REVIEW
 } from "./actionTypes";
import {
  getReviewsSuccess,
  getReviewsFail,
  addReviewSuccess,
  addReviewFail,
  updateReviewSuccess,
  updateReviewFail,
  deleteReviewSuccess,
  deleteReviewFail,
  // getReviewProfileSuccess,
  // getReviewProfileFail,
} from "./actions";

//Include Both Helper File with needed methods
import { 
  getReviews,
  // getReviewProfile,
  addNewReview,
  updateReview,
  deleteReview,
} from "../../helpers/backend_helper";
import { showPopup } from "../popup/actions";

function* fetchReviews({payload:{date,query,offset,page_size}}) {
  try {
    const response = yield call(getReviews,{date,query,offset,page_size});
    yield put(getReviewsSuccess(response));
  } catch (error) {
    yield put(getReviewsFail(error));
        yield put(showPopup({title:error.response.data.message,error:true}));
  }
}

function* onUpdateReview({ payload: { review, history } }) {
  try {
   let response = yield call(updateReview, review);
  //  if(response.file_src || review.removeImage) review.image = response.file_src
    yield put(updateReviewSuccess(review));
        yield put(showPopup({title:response.message,success:true}));
    history && history.push("/reviews")
  } catch (error) {
    yield put(updateReviewFail(error));
        yield put(showPopup({title:error.response.data.message,error:true}));
  }
}

function* onDeleteReview({ payload: review }) {

  try {
  let response =  yield call(deleteReview, review);
    yield put(deleteReviewSuccess(review));
        yield put(showPopup({title:response.message,success:true}));

  } catch (error) {
    yield put(deleteReviewFail(error));
        yield put(showPopup({title:error.response.data.message,error:true}));
  }
}

function* onAddNewReview({ payload: { user,history }}) {
  try {
    let response = yield call(addNewReview, user)
    yield put(addReviewSuccess(response.data))
        yield put(showPopup({title:response.message,success:true}));
    history.push("/reviews")
  } catch (error) {
    yield put(addReviewFail(error))
        yield put(showPopup({title:error.response.data.message,error:true}));
  }
}


// function* fetchReviewProfile() {
//   try {
//     const response = yield call(getReviewProfile);
//     yield put(getReviewProfileSuccess(response));
//   } catch (error) {
//     yield put(getReviewProfileFail(error));
//   }
// }

function* reviewsSaga() {
  yield takeEvery(GET_REVIEWS, fetchReviews);
  yield takeEvery(ADD_NEW_REVIEW, onAddNewReview);
  yield takeEvery(UPDATE_REVIEW, onUpdateReview);
  yield takeEvery(DELETE_REVIEW, onDeleteReview);
  // yield takeEvery(GET_ADMIN_PROFILE, fetchReviewProfile);
}

export default reviewsSaga;
